import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-general-hints',
  templateUrl: './general-hints.component.html',
  styleUrls: ['./general-hints.component.css']
})
export class GeneralHintsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
